import { render, staticRenderFns } from "./autopo.vue?vue&type=template&id=a035a704&scoped=true&"
import script from "./autopo.vue?vue&type=script&lang=js&"
export * from "./autopo.vue?vue&type=script&lang=js&"
import style0 from "./autopo.vue?vue&type=style&index=0&id=a035a704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a035a704",
  null
  
)

export default component.exports